module.exports = __webpack_public_path__ + "img/69.28d459aa.jpg";